
import { Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import Brand from '@/api/models/Brand'
import { handleRequest, setFavicon, setTitle } from '@/shared/components/helper'
import HandleFunctions from '@/models/HandleFunctions'
import { RootStateMutations } from '@/store/mutations'
import AuthCheckMixin from '@/shared/mixins/AuthCheckMixin.vue'
import { mixins } from 'vue-class-component'

@Component({})
export default class BaseLayout extends mixins(AuthCheckMixin) {
    @Getter('isLoading')
    readonly loading!: boolean

    @Getter('currentAccount')
    readonly currentAccount!: number

    @Getter('currentCampaign')
    readonly currentCampaign!: number

    @Getter('brand')
    brand!: Brand

    @Action('loadBrand')
    loadBrand!: () => void

    private alert = {
        msg: '',
        type: 'error'
    }

    async created (): Promise<void> {
        if (!this.brand.name) {
            try {
                await this.loadBrand()
            } catch (e) {
                await this.$router.push('/')
            }
        }

        setFavicon(this.brand)
        setTitle(this.brand)
    }

    async updated (): Promise<void> {
        this.$store.commit(RootStateMutations.setLoading, false)
    }

    get logoUrl (): string {
        return `${process.env.VUE_APP_CDN}${this.brand.key}/logo/logo_icon.svg`
    }

    get crmUrl (): string {
        return 'javascript:void()'
    }

    get integrationCrmUrl (): string {
        return this.crmUrl
    }

    get docLink (): string {
        return this.brand.docLink
    }

    public pushRoute (route: string): void {
        if (route !== this.$router.currentRoute.name) {
            this.$router.push({ name: route })
        }
    }

    public async handleWithAlerts (body: () => Promise<void>, successMessage: string): Promise<void> {
        const handler: HandleFunctions = {
            tryBody: async () => {
                await body()
            },
            onSuccess: () => this.showSuccess(successMessage),
            onFailure: (message) => this.showError(message)
        }

        await handleRequest(handler)
    }

    public async handleRequest (handler: HandleFunctions): Promise<void> {
        const handleFunctions: HandleFunctions = {
            tryBody: handler.tryBody,
            onSuccess: () => {
                if (handler.onSuccess) {
                    handler.onSuccess()
                }
            },
            onFailure: (message) => {
                if (handler.onFailure) {
                    handler.onFailure(message)
                } else {
                    this.showError(message)
                }
            },
            onFinal: handler.onFinal
        }

        await handleRequest(handleFunctions)
    }

    public showError (message: string): void {
        this.showAlert('error', message)
    }

    public showSuccess (message: string): void {
        this.showAlert('success', message)
    }

    public showAlert (type: string, message: string): void {
        this.alert.type = type
        this.alert.msg = message
    }

    public closeAlert (): void {
        this.alert.msg = ''
    }
}
